import { useEffect, useState } from 'react';

export default function useActiveOptionsSectionId(
  sectionIds: readonly string[],
  isActive: boolean
): string | undefined {
  const [activeSectionId, setActiveSectionId] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    if (!isActive) {
      setActiveSectionId(undefined);

      return;
    }

    function computeActive(): string | undefined {
      let lastScrolledPastIndex = -1;

      for (let i = 0; i < sectionIds.length; i++) {
        const el = document.getElementById(sectionIds[i]);
        if (el && el.getBoundingClientRect().top < 0) {
          lastScrolledPastIndex = i;
        }
      }

      if (lastScrolledPastIndex === -1) {
        return sectionIds.find(id => document.getElementById(id) !== null);
      }

      return sectionIds[
        Math.min(lastScrolledPastIndex + 1, sectionIds.length - 1)
      ];
    }

    function handleScroll() {
      setActiveSectionId(computeActive());
    }

    setActiveSectionId(computeActive());
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isActive, sectionIds]);

  return activeSectionId;
}
